














































import { Workorder, WorkordersApi } from 'performo-api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class DuplicateOrder extends Vue {
  @Prop({ required: true })
  private orderProp!: Workorder;

  @Prop({ required: false })
  isOrderClosedOut!: boolean;

  private ordersApi!: WorkordersApi;
  private showDialog = false;
  private loading = false;

  private order!: Workorder;
  private newAssignTo!: string;

  data() {
    return {
      order: undefined,
      newAssignTo: undefined
    };
  }

  private mounted() {
    this.order = this.orderProp;
  }

  private async handleDuplicateOrder() {
    if (this.order.workorderId) {
      this.loading = true;
      try {
        var duplicatedOrder = await this.ordersApi.duplicateWorkOrder({
          workorderId: this.order.workorderId,
          assignTo: this.newAssignTo
        });
        if (duplicatedOrder.workorderId) {
          this.$router.push({
            name: 'work-order-detail',
            params: { id: duplicatedOrder.workorderId }
          });
        }
      } catch (error) {
        this.$emit('error', error);
      }
    }
    this.loading = false;
    this.showDialog = false;
  }

  private closeDialog() {
    this.showDialog = false;
  }
}
